"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
exports.Backdrop = styled_components_1.default.div `
  background: ${props => props.theme.Color.Layout.Darkest};
  bottom: 0px;
  left: 0px;
  position: fixed;
  right: 0px;
  top: 0px;
  z-index: ${style_1.default.Depth.Position.F50};
  opacity: ${style_1.default.Design.Opacity.Translucent}
`;
